module.exports = __webpack_public_path__ + "static/source-sans-pro-v13-latin-ext_latin-300-fb71b60d49e332e9a5fd31f55a7997a2.ttf";